// import node module libraries
import { Fragment, useEffect, useState } from 'react';
import { Accordion, Col, Row, Breadcrumb, Card, Form, Button, Spinner, Table } from 'react-bootstrap';
import { Trash, Plus, Clipboard } from 'react-feather';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

// import notification component
import Notification, { handleShowNotification } from 'components/elements/notification/Notification';

// Import required custom components
import DotBadge from 'components/elements/bootstrap/DotBadge';

const ConnectorSFTPSettings = ({ activeKey }) => { // activeKey als Prop erhalten
	const { t } = useTranslation();
	const [notification, setNotification] = useState({ variant: '', title: '', message: '' });
	const [isLoading, setIsLoading] = useState(true);
	const [sftpStatus, setSFTPStatus] = useState({ data: 'unknown' });
	const [sftpHealthz, setSFTPHealthz] = useState({ data: 'unknown' });

	const auth = useAuthUser();

	// API-Call Options
	const authHeader = useAuthHeader();
	const options = {
		params: {},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	// API-Call for all Data
	const getSFTPStatus = async () => {
		setIsLoading(true);

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.get(`${baseURL}/proxy/sftp/healthz`, options)
			.then(response => {
				const responseData = response;
				setSFTPHealthz(responseData);
				setIsLoading(false);
			})
			.catch((error) => {
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				setSFTPStatus({ data: 'error', statusText: errorMessage });
				setIsLoading(false);
			});

		await axios.get(`${baseURL}/proxy/sftp/api/v2/status`, options)
			.then(response => {
				const responseData = response;
				setSFTPStatus(responseData);
				setIsLoading(false);
			})
			.catch((error) => {
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				setSFTPStatus({ data: 'error', statusText: errorMessage });
				setIsLoading(false);
			});
	};

	useEffect(() => {
		// Check if the current tab is active before making the API call
		if (activeKey === 'connector.sftp') {
			getSFTPStatus();
		}
	}, [activeKey]); // Run effect when activeKey changes

	const copyToClipboard = () => {
		navigator.clipboard.writeText('@custom_notes');
		handleShowNotification(setNotification, 'success', 'Kopiert', 'Der Text wurde in die Zwischenablage kopiert!');
	};

	// Component Status-Badge
	const statusBadge = (value) => {
		return (
			<Fragment>
				<DotBadge
					bg={
						value.includes('unkown')
							? 'info'
							: value === 'ok'
								? 'success'
								: value.includes('error')
									? 'danger'
									: 'info'
					}
				></DotBadge>
				{
					value.includes('unkown')
						? t('Unkown')
						: value === 'ok'
							? t('Running')
							: value.includes('error')
								? t('Error')
								: t('Unkown Status')
				}
			</Fragment>
		);
	};

	return (
		<Fragment>
			{notification.show && (
				<Notification variant={notification.variant} title={notification.title} message={notification.message} show={notification.show} setNotification={setNotification} />
			)}
			<Row>
				<Col xl={{ offset: 1, span: 10 }} lg={{ offset: 1, span: 10 }} md={12}>
					<Card className="mb-4">
						<Card.Header className="d-flex align-items-center justify-content-between">
							<h4 className="mb-0">{t('Status & Monitoring')}</h4>
						</Card.Header>
						<Card.Body>
							{isLoading ? (
								<div className="d-flex justify-content-center">
									<Spinner animation="border" role="status">
										<span className="visually-hidden">Loading...</span>
									</Spinner>
								</div>
							) : (
								<>
									<Row>
										<Col lg={12} md={12} className="mt-1">
											<Table hover size="sm">
												<thead>
													<tr>
														<th>{t('Status')}</th>
														<th>{t('Code')}</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>{statusBadge(sftpHealthz.data)}</td>
														<td>{sftpHealthz.status} {sftpHealthz.statusText}</td>
													</tr>
												</tbody>
											</Table>
										</Col>
									</Row>
									<Row>
										<Col lg={12} md={12} className="mt-1">

										</Col>
									</Row>
								</>
							)}
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Fragment>
	);
};

export default ConnectorSFTPSettings;